module.exports = __webpack_public_path__ + "img/navbar.bcbe0b41.svg";